import { render, staticRenderFns } from "./ValueMappingTable.vue?vue&type=template&id=7b336d03&scoped=true"
import script from "./ValueMappingTable.vue?vue&type=script&lang=js"
export * from "./ValueMappingTable.vue?vue&type=script&lang=js"
import style0 from "./ValueMappingTable.vue?vue&type=style&index=0&id=7b336d03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b336d03",
  null
  
)

export default component.exports